import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MANAGE_NOTIFICATION_STATES } from "./notification-routing.states";
import { NotificationSettingsComponent } from "./components/notification-settings/notification-settings.component";
import { UiModule } from "@webapp/ui/ui.module";
import { FormsModule } from "@angular/forms";
import { NotificationLayoutComponent } from "./components/notification-layout/notification-layout.component";
import { NotificationsServiceProvider } from "./notification.provider";
import { NotificationCategoryComponent } from "./components/notification-category/notification-category.component";
import { AccountNotificationComponent } from "./components/account-notification/account-notification.component";
import { PersonalNotificationComponent } from "./components/personal-notification/personal-notification.component";
import { ToggleChangeService } from "./services/toggle-change.service.ts.service";
import { UIRouterModule } from "@uirouter/angular";

@NgModule({
  declarations: [NotificationSettingsComponent, NotificationLayoutComponent, NotificationCategoryComponent, AccountNotificationComponent, PersonalNotificationComponent],
  imports: [CommonModule, UiModule, FormsModule, UIRouterModule.forChild({ states: MANAGE_NOTIFICATION_STATES })],
  providers: [ToggleChangeService, NotificationsServiceProvider],
})
export class NotificationModule {}
